import { useEffect } from 'react';

const HUBSPOT_PORTAL_ID = '21590657';
const SCRIPT_ID = 'hs-script-loader';

/**
 * Carga el chat de HubSpot solo cuando el componente está montado.
 * Al desmontar, elimina el widget y el script para que no aparezca en otras vistas (mapas, etc.).
 * Documentación: https://developers.hubspot.com/docs/api/conversation/chat-widget-sdk
 */
const HubSpotChat = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
    document.body.appendChild(script);

    return () => {
      if (window.HubSpotConversations?.widget?.remove) {
        window.HubSpotConversations.widget.remove();
      }
      const existingScript = document.getElementById(SCRIPT_ID);
      if (existingScript?.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
      }
      window.hsConversationsOnReady = [];
    };
  }, []);

  return null;
};

export default HubSpotChat;
